import React, { Component } from 'react'
import { debounce } from 'lodash'
import InputText from './InputText'
import InputLabel from './InputLabel'
import { i18n } from '../i18n/i18n'

export interface SearchPickerOption {
  id: string | number
  value: string
}

interface Props {
  name: string
  value: string
  options?: SearchPickerOption[]
  label?: string
  readonly?: boolean
  onSearch: (name: string, term: string) => void
  onChange: (name: string, value: string) => void
  onBlur?: (name: string) => void
  onSelect?: (name: string, option: SearchPickerOption) => void
}

export default class SearchPicker extends Component<Props> {
  constructor (props: Props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
  }

  handleSearch = debounce((name: string, value: string) => {
    const { readonly, onSearch } = this.props
    if (readonly) return
    onSearch(name, value)
  }, 300)

  handleChange (name: string, value: string) {
    this.props.onChange(name, value)
    this.handleSearch(name, value)
  }

  handleSelect (option: SearchPickerOption) {
    const { name, onSelect } = this.props
    this.props.onChange(name, option.value)
    if (onSelect) onSelect(name, option)
  }

  handleBlur = debounce((name: string) => {
    const { onBlur } = this.props
    if (onBlur) onBlur(name)
  }, 200)

  get options () {
    const { options } = this.props
    return options &&
      options.map(option => (
        <div
          className="py-2 px-3 cursor-pointer hover:bg-gray-100"
          onClick={() => this.handleSelect(option)}
          key={option.id}>
          {option.value}
        </div>
      ))
  }

  get selectbox () {
    return this.props.options &&
      <div className="border border-solid border-primary z-10 absolute bg-white w-full -mt-4 border-t-0">
        {this.options}
      </div>
  }

  render () {
    return (
      <div className="relative">
        <InputLabel text={this.props.label} />
        <InputText
          name={this.props.name}
          value={this.props.value}
          readonly={this.props.readonly}
          placeholder={i18n("Search")}
          icon="search"
          onChange={this.handleChange}
          onFocus={this.handleSearch}
          onBlur={this.handleBlur} />
        {this.selectbox}
      </div>
    )
  }
}
